import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@repo/ui/components/ui/accordion";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { trpc } from "@/router";

// Mirrors the `moderation_action` pg enum. Kept as a local union so this
// client component doesn't pull in server types directly.
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const ACTION_LABELS = {
  approve: "Godkänd",
  reject: "Avvisad",
  reposition: "Flyttad",
  edit: "Redigerad",
  lock: "Låst för granskning",
  unlock: "Upplåst"
};
export function AuditHistoryAccordion(t0) {
  const $ = _c(13);
  const {
    entityType,
    entityId
  } = t0;
  let t1;
  if ($[0] !== entityId || $[1] !== entityType) {
    t1 = trpc.moderation.eventsFor.queryOptions({
      entityType,
      entityId
    });
    $[0] = entityId;
    $[1] = entityType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: t2,
    isLoading
  } = useQuery(t1);
  let t3;
  if ($[3] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const events = t3;
  let t4;
  if ($[5] !== events.length) {
    t4 = /*#__PURE__*/_jsxs(AccordionTrigger, {
      className: "px-4 py-2 text-xs font-medium uppercase tracking-wider text-gray-500 hover:no-underline",
      children: ["Historik (", events.length, ")"]
    });
    $[5] = events.length;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== events || $[8] !== isLoading) {
    t5 = /*#__PURE__*/_jsx(AccordionContent, {
      className: "px-4 pb-3",
      children: isLoading ? /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-2 text-xs text-gray-500",
        children: [/*#__PURE__*/_jsx(Loader2, {
          className: "h-3 w-3 animate-spin"
        }), "Laddar\u2026"]
      }) : events.length === 0 ? /*#__PURE__*/_jsx("p", {
        className: "text-xs text-gray-500",
        children: "Inga h\xE4ndelser \xE4nnu."
      }) : /*#__PURE__*/_jsx("ul", {
        className: "space-y-2",
        children: events.map(_temp)
      })
    });
    $[7] = events;
    $[8] = isLoading;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = /*#__PURE__*/_jsx(Accordion, {
      type: "single",
      collapsible: true,
      className: "border-t",
      children: /*#__PURE__*/_jsxs(AccordionItem, {
        value: "history",
        className: "border-0",
        children: [t4, t5]
      })
    });
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp(event) {
  return /*#__PURE__*/_jsxs("li", {
    className: "rounded border border-gray-100 bg-gray-50 p-2 text-xs",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center justify-between",
      children: [/*#__PURE__*/_jsx("span", {
        className: "font-semibold text-gray-800",
        children: ACTION_LABELS[event.action] ?? event.action
      }), /*#__PURE__*/_jsx("span", {
        className: "text-gray-500",
        children: new Date(event.createdAt).toLocaleString("sv-SE")
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "mt-0.5 text-gray-600",
      children: [event.actorName ?? "Ok\xE4nd", event.fromState && event.toState && /*#__PURE__*/_jsxs("span", {
        className: "ml-2 text-gray-400",
        children: [event.fromState, " \u2192 ", event.toState]
      })]
    }), event.reason && /*#__PURE__*/_jsxs("p", {
      className: "mt-1 italic text-gray-600",
      children: ["\"", event.reason, "\""]
    }), event.diff && Object.keys(event.diff).length > 0 && /*#__PURE__*/_jsx("pre", {
      className: "mt-1 whitespace-pre-wrap break-words text-[10px] text-gray-500",
      children: JSON.stringify(event.diff, null, 2)
    })]
  }, event.id);
}